<template>
  <div>
    <mu-content-block class="blueHeader">
      <mu-flexbox>
        <mu-flexbox-item>
          {{title}}
        </mu-flexbox-item>
        <mu-flexbox-item align="right">
          <md-icon
            slot="default"
            style="cursor:pointer"
            @click.native="closeDialog('addFoodDialog')"
            v-text="'close'"
          >
          </md-icon>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-content-block>
    <div class="scrollable-area">
      <mu-content-block style="padding: 16px 24px;">
        {{$t('message.foodDiaryLandingExplain')}}

        <span v-if="recents.length == 0">
          {{$t('message.foodDiaryRecentsEmpty')}}
        </span>

        <span v-if="recents.length > 0">
          {{$t('message.foodDiaryHasRecents')}}
        </span>

      </mu-content-block>
      <mu-content-block style="padding: 0px 24px 24px 24px;">
        <mu-row gutter>
          <mu-col :desktop="recents.length > 0 ? '50': '100'" :tablet="recents.length > 0 ? '50': '100'" width="100">
            <mu-row gutter style="margin-bottom: 24px">
              <mu-col desktop="50" tablet="50" width="50">
                <mu-paper align="center" class="paperCard">
                  <mu-content-block class="landingCard" @click.native="userDecidesTo('a')">
                    <mu-flexbox align="center" justify="center" style="height: 100%;">
                      <mu-flexbox-item align="center">
                        <img style="height: 58px" src="static/food-diary/search.png"/>
                        <div class="labelBelowImg">{{$t('message.searchText')}}</div>
                      </mu-flexbox-item>
                    </mu-flexbox>
                  </mu-content-block>
                </mu-paper>
              </mu-col>
              <mu-col desktop="50" tablet="50" width="50">
                <mu-paper align="center" class="paperCard">
                  <mu-content-block class="landingCard" @click.native="userDecidesTo('mm')">
                    <mu-flexbox align="center" justify="center" style="height: 100%;">
                      <mu-flexbox-item align="center">
                        <img style="height: 58px" src="static/food-diary/baseline-restaurant_menu-24px.svg"/>
                        <div class="labelBelowImg">{{$t('message.foodDiaryLoadFromMyMeals')}}</div>
                      </mu-flexbox-item>
                    </mu-flexbox>
                  </mu-content-block>
                </mu-paper>
              </mu-col>
            </mu-row>
            <mu-raised-button
              @click.native="copyYesterdaysMeal"
              class="yesterday-btn"
              icon="refresh"
              :label="$t('message.foodDiaryRepeatYesterdayMeal')"
              :disabled="!isDateToday"
              fullWidth
            >
            </mu-raised-button>
          </mu-col>
          <mu-col :desktop="recents.length > 0 ? '50': '100'" :tablet="recents.length > 0 ? '50': '100'" width="100" class="mobileTop">
            <mu-card>
              <mu-list id="recents">
                <mu-list-item v-for="item, index in recents" :key="'recent-' + index" :title="item.food_name"
                              @click.native="selectRecent(item)">
                  <mu-icon class="left8" slot="left" value="history"/>
                </mu-list-item>
              </mu-list>
            </mu-card>
          </mu-col>
        </mu-row>
      </mu-content-block>
    </div>
  </div>
</template>
<script>


  import FoodApi from '../../../api/Food'
  import MuContentBlock from "../../../../node_modules/muse-ui/src/contentBlock/contentBlock";
  import MuFlexbox from "../../../../node_modules/muse-ui/src/flexbox/flexbox";
  import MuFlexboxItem from "../../../../node_modules/muse-ui/src/flexbox/flexboxItem";

  export default {
    components: {
      MuFlexboxItem,
      MuFlexbox,
      MuContentBlock
    },
    name: 'fd-landing-dialog',
    props: {
      title: {
        type: String,
        default: ""
      },
      mealTypeId: {
        type: Number,
        default: 1
      },
      date: {
        type: String,
        default: ''
      }

    },
    watch: {
      'mealTypeId': function () {
        let self = this;
        FoodApi.getRecents(self.mealTypeId)
          .then(function (response) {
            self.recents = response.data;
          })
      }
    },
    data() {
      return {
        isRecentsLoading: true,
        recents: []
      }
    },
    mounted() {
      let self = this;


      FoodApi.getRecents(self.mealTypeId)
        .then(function (response) {
          self.recents = response.data;
        })
    },
    methods: {
      copyYesterdaysMeal() {
        let self = this;
        FoodApi.copyYesterdaysMeal(self.mealTypeId)
          .then(function (response) {
            self.$emit('closeDialogAndReload');
          })
          .catch(function () {
            let meal;
            switch (self.mealTypeId) {
              case 1:
                meal = self.$t('message.foodDiaryBreakfast');
                break;
              case 2:
                meal = self.$t('message.foodDiaryLunch');
                break;
              case 3:
                meal = self.$t('message.foodDiaryDinner');
              case 4:
                meal = self.$t('message.foodDiarySnack');
                break;
            }
          })
      },
      /**
       *
       * Either search or barcode.
       * @param option
       */
      userDecidesTo(option) {
        this.$emit('choseToSearchWith', option);
      },
      selectRecent(item) {
        this.$emit('onRecentItemSelected', item.fs_food_id);
      },
      closeDialog() {
        this.$emit('closeDialog')
      }
    },
    computed: {
      isDateToday() {
        let self = this;
        let date = moment(self.date);


        let today = moment();

        if (date.isSame(today, 'day')) {
          return true;
        }
        else return false;

      }
    }
  }
</script>
<style>
  .yesterday-btn {
    height: 56px !important;
  }

  .add-food-dialog .landingCard {
    height: 160px;
    padding: 8px 16px;
    cursor: pointer;
  }

  .add-food-dialog {
    width: 810px;
  }

  @media (max-width: 479px) {

    .mobileTop {
      margin-top: 24px;
    }

    .yesterday-btn {
      font-size: 12px !important;
    }
  }

  @media (min-width: 0px) and (max-width: 768px) {
    .add-food-dialog {
      width: 100% !important;
    }

    .scrollable-area {
      width: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
    }
  }

  .add-food-dialog .labelBelowImg {
    margin-top: 8px;
    font-weight: 400;
  }

  @media (min-width: 993px) {
    .add-food-dialog .row .desktop-50 {
      width: calc((100% - 24px * 1) / 2) !important;
    }
  }

  .removePadding .mu-card-header-title {
    padding-right: 0;
  }

  .add-food-dialog div#recents .mu-item-title-row .mu-item-title {
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100% !important;
    overflow: hidden;
  }

  .add-food-dialog button.mu-raised-button.yesterday-btn.mu-raised-button-full {
    min-height: 56px;
  }
</style>



// WEBPACK FOOTER //
// LandingDialog.vue?3864297b